// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".d4bda864bccf9808fa99e0258026d0ef14494021.chunk.js";
};